module.exports = __webpack_public_path__ + "static/radical-20c684a45f059ab1b57e08a55301af17.gif";